module.exports = __webpack_public_path__ + "static/media/lock-fill-white.9f6b2c2f.svg";